module.exports = __webpack_public_path__ + "img/MEMBERSPARON_LOGO.e1b954cc.svg";